import type { RefObject } from 'react';
import { createContext, useContext } from 'react';

export interface PageContextType {
  /**
   * A reference to the Page container element, if present, which wraps a Page
   * header, content and footer. Useful for layout calculations.
   */
  containerRef: RefObject<HTMLDivElement>;
  /**
   * A reference to the Page header element, if present. Useful for layout
   * calculations.
   */
  headerRef: RefObject<HTMLDivElement>;
  /**
   * A reference to the Page footer element, if present. Useful for layout
   * calculations.
   */
  footerRef: RefObject<HTMLDivElement>;
}

const PageContext = createContext<PageContextType>({
  containerRef: { current: null },
  headerRef: { current: null },
  footerRef: { current: null },
});

export const PageProvider = PageContext.Provider;

export const usePageContext = () => useContext(PageContext);
